var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "send-info"
  }, [_c('b-modal', {
    attrs: {
      "id": "signedContract",
      "centered": "",
      "size": "md",
      "no-close-on-backdrop": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "send-contract-info text-center"
        }, [_c('h4', [_vm._v("Signed Contract List")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', [_c('div', {
    staticClass: "sendInfo-form"
  }, [_c('div', [_vm.groupedContracts.length > 0 ? _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("Contract Type")]), _c('th', [_vm._v("Contract Name")]), _c('th', [_vm._v("Level")])])]), _c('tbody', [_vm._l(_vm.groupedContracts, function (contract, typeIndex) {
    return [_c('tr', {
      key: "contract-".concat(typeIndex, "-row")
    }, [_c('td', {
      attrs: {
        "rowspan": contract.data.length
      }
    }, [_vm._v(" " + _vm._s(contract.contract_display_name) + " ")]), _c('td', [_vm._v(_vm._s(contract.data[0].contract_item_display_name))]), _c('td', [_vm._v(_vm._s(contract.data[0].contract_level))])]), _vm._l(contract.data.slice(1), function (item, itemIndex) {
      return _c('tr', {
        key: "contract-".concat(typeIndex, "-item-").concat(itemIndex)
      }, [_c('td', [_vm._v(_vm._s(item.contract_item_display_name))]), _c('td', [_vm._v(_vm._s(item.contract_level))])]);
    })];
  })], 2)]) : _c('div', [_vm._v("No contracts available.")])])])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }